export function toHourSeconds(seconds: number) {
  const totalQoldiq = seconds % 3600
  const totalHours = (seconds - totalQoldiq) / 3600
  const totalSeconds = totalQoldiq % 60
  const totalMinutes = (totalQoldiq - totalSeconds) / 60

  return { totalHours, totalMinutes, totalSeconds }
}